import React from "react";
import { SeoAnalysisReport } from "../seoAnalyzer";
import { Share2, Globe, Image as ImageIcon } from "lucide-react";

interface SocialPreviewProps {
  meta: SeoAnalysisReport["meta"];
  domain: string;
}

export const SocialPreview: React.FC<SocialPreviewProps> = ({ meta, domain }) => {
  const displayTitle = meta.ogTitle || meta.title || `${domain} - Official Site`;
  const displayDesc = meta.ogDescription || meta.description || "No open graph description provided.";
  const displayImage = meta.ogImage;

  return (
    <div style={{ padding: "1rem 0" }}>
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h3 style={{ color: "var(--neon-purple)", display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
          <Share2 size={20} /> SOCIAL LINK PREVIEW CARD
        </h3>
        <p style={{ color: "var(--text-secondary)", fontSize: "0.85rem", marginTop: "0.4rem" }}>
          This is how your link appears when shared on Twitter / X, Discord, Facebook, and LinkedIn.
        </p>
      </div>

      <div className="social-preview-card">
        <div className="social-img-box">
          {displayImage ? (
            <img src={displayImage} alt="Social Card Preview" onError={(e) => {
              (e.target as HTMLElement).style.display = 'none';
            }} />
          ) : (
            <div style={{ textAlign: "center", color: "var(--text-muted)" }}>
              <ImageIcon size={48} style={{ opacity: 0.3, marginBottom: "0.5rem" }} />
              <div style={{ fontSize: "0.8rem", fontFamily: "var(--font-mono)" }}>No og:image tag detected</div>
            </div>
          )}
        </div>

        <div className="social-content">
          <div className="social-domain">
            <Globe size={12} style={{ display: "inline", marginRight: "0.3rem" }} />
            {domain}
          </div>
          <div className="social-title-text">{displayTitle}</div>
          <div className="social-desc-text">{displayDesc}</div>
        </div>
      </div>
    </div>
  );
};
